import { ContentExperimentDTO, ContentExperimentListResponse, } from '@wit-support/admin-contracts';
import { CONTENT_API_BASE as BASE, contentJsonInit as jsonInit, contentQs as qs, contentRequest as request, } from '../api.js';
/** GET /experiments — страница экспериментов, новые первыми (порядок движка). */
export function listExperiments(query) {
    return request(ContentExperimentListResponse, `${BASE}/experiments${qs({
        status: query.status,
        page: String(query.page),
        pageSize: String(query.pageSize),
    })}`);
}
/** POST /experiments — новый эксперимент (content.manage, аудит). */
export function createExperiment(body) {
    return request(ContentExperimentDTO, `${BASE}/experiments`, jsonInit('POST', body));
}
/** PATCH /experiments/:id — статус и/или конец (content.manage, аудит). */
export function updateExperiment(id, body) {
    return request(ContentExperimentDTO, `${BASE}/experiments/${encodeURIComponent(id)}`, jsonInit('PATCH', body));
}
//# sourceMappingURL=experiments.js.map